import { useEffect, useState } from "react";
import { ContentTypeView, SessionRole } from "nystem-components";
import app from "nystem";
import { CastContext } from "../../client/castContext.js";
import CastTest from "./test.js";

const CastDisplay = () => {
  const [hd, setHd] = useState(true);
  const [video, setVideo] = useState();
  const [subtitles, setSubtitles] = useState(false);

  useEffect(() => {
    window.__mediaqueueDisplayReceive = ({ data }) => {
      setVideo(data?.video);
      setSubtitles(data?.subtitles === true);
      if (data) setHd(data.hd !== false);
    };
    window.webkit?.messageHandlers?.mediaqueueDisplay?.postMessage({ type: "ready" });
    return () => {
      delete window.__mediaqueueDisplayReceive;
    };
  }, []);

  return (
    <CastContext.Provider value={{ hd, subtitles, receiver: true }}>
      <div className="fixed inset-0 bg-black text-white">
        {video ? (
          <SessionRole userrole="logged-in">
            <ContentTypeView
              key={video._id}
              contentType="video"
              view={app.populatedViews.mediaqueueCast.views.screen}
              value={video}
            />
          </SessionRole>
        ) : (
          <p role="status" className="p-8 text-center text-lg text-white">
            Playback is not active on this display. Use Resume here on your phone to play here.
          </p>
        )}
      </div>
    </CastContext.Provider>
  );
};

const CastReceiver = () =>
  new URLSearchParams(window.location.search).get("test") === "1" ? <CastTest /> : <CastDisplay />;

export default CastReceiver;
